<div class="content-wrapper-inner">
  <app-account-form></app-account-form>
</div>
